/**
 * Currently we hardcode some text in English, so it always has to use LTR
 * layout, even if the containing layout is RTL. This method adds Unicode
 * direction-override markers to force LTR ordering.
 *
 * @see https://stackoverflow.com/a/56159736
 */
function forceLTR(string: string): string {
  return `\u202A${string}\u202C`
}

export const addCaption = forceLTR('Add caption...')
export const addComment = forceLTR('Add a comment...')
export const timestamp = forceLTR('1 minute ago')
